import { ThemeEvents } from '@theme/events';
window.theme = window.theme || {};
theme.utils = {
    debounce: function(wait, callback, immediate) {
        var timeout;
        return function() {
          var context = this, args = arguments;
          var later = function() {
            timeout = null;
            if (!immediate) callback.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) callback.apply(context, args);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Mega menu hover
    const megaMenuHoverLinks = document.querySelectorAll('.js-menu-hover-link');
    if(megaMenuHoverLinks.length > 0) {
        megaMenuHoverLinks.forEach(link => {
            link.addEventListener('mouseover', function(e) {
                const parent = e.target.closest('.custom-mega-menu__grid');
                const targetID = e.target.getAttribute('data-target');
                const childMegaMenuHoverLinks = parent.querySelectorAll('.js-menu-hover-link');
                const megaMenuHoverContents = parent.querySelectorAll('.mega-menu-left-contents');
                childMegaMenuHoverLinks.forEach(link => {
                    link.classList.remove('active');
                });
                e.target.classList.add('active');
                megaMenuHoverContents.forEach(el => {
                    el.classList.remove('active');
                });
                const targetContainer = parent.querySelector(`.mega-menu-left-contents[data-hover=${targetID}]`);
                targetContainer.classList.add('active');
            });
        })
    }
    const productImageHover = document.querySelectorAll('.contains-mega-menu-image [data-image-target]');
    if(productImageHover.length > 0) {
        productImageHover.forEach(link => {
            const parent = link.closest('.contains-mega-menu-image');
            const defaultImg = parent.querySelector('.custom-mega-menu-image-wrap img[data-image="default"]');
            let imgToShow;
            link.addEventListener('mouseover', theme.utils.debounce(200, function(e) {   
                const imgTarget = e.target.getAttribute('data-image-target');
                imgToShow = parent.querySelector(`img[data-image=${imgTarget}]`);
                const currentImgSrc = imgToShow.getAttribute('src');
                const imgSrc = imgToShow.getAttribute('data-src-url');
                if(currentImgSrc === '') {
                    imgToShow.setAttribute('src', imgSrc);
                }
                defaultImg.classList.remove('active');
                imgToShow.classList.add('active');
            }));

            link.addEventListener('mouseleave', theme.utils.debounce(200, function() {
                imgToShow.classList.remove('active');
                defaultImg.classList.add('active');
            }));
        });
    }

    // Custom mobile menu
    const menuBtns = document.querySelectorAll('.js-open-next-menu');
    if(menuBtns.length > 0) {
        menuBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.target.closest('.mobile-slide-menu-parent')?.classList.remove('active');
                e.target.closest('.mobile-nav__has-sublist')?.querySelector('.mobile-slide-menu-parent')?.classList.add('active');
            });
        });
    }
    const menuBackBtns = document.querySelectorAll('.js-back-to-prev-menu');
    if(menuBackBtns.length > 0) {
        menuBackBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                const parent = e.target.closest('.mobile-slide-menu-parent');
                if(parent) {
                    parent.closest('.mobile-slide-menu-parent:not(.active)')?.classList.add('active');
                    parent.classList.remove('active');
                }
            });
        })
    }

    // KK Footer Links - from previous theme (modified to use menu link and vanilla JS)
    // Hide the "Hide Popular Links" when the page loads
    const showPopularSearchesBtn = document.querySelector('.menu__item a[href="#popular-searches"]');
    const popularSearchesContainer = document.getElementById('popular-searches');
    if(showPopularSearchesBtn && popularSearchesContainer) {
        showPopularSearchesBtn.addEventListener('click', function(e) {
            popularSearchesContainer.style.display = 'block';
        });
    }

    // Featured product card: wrap all items except gallery in a div so grid has 2 children (gallery + wrapper)
    wrapFeaturedProductCardColumn();
});

document.addEventListener(ThemeEvents.FilterUpdate, (e) => { wrapFeaturedProductCardColumn(); });
document.addEventListener('collection-grid-updated', (e) => { wrapFeaturedProductCardColumn(); });

function wrapFeaturedProductCardColumn() {
    document.querySelectorAll('.product-grid__item--featured .product-card__content').forEach(function(content) {
        if (content.querySelector(':scope > .featured-product-card__content-column')) return; // already wrapped
        var gallery = content.querySelector(':scope > .card-gallery');
        if (!gallery) return;
        var toWrap = [];
        for (var i = 0; i < content.children.length; i++) {
            var el = content.children[i];
            if (el !== gallery && !el.classList.contains('product-grid-view-zoom-out--details')) toWrap.push(el);
        }
        if (toWrap.length === 0) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'featured-product-card__content-column';
        gallery.after(wrapper);
        toWrap.forEach(function(el) { wrapper.appendChild(el); });
    });
}
if (typeof window.theme !== 'undefined') window.theme.wrapFeaturedProductCardColumn = wrapFeaturedProductCardColumn;

/*  ===================================
 *  FREE SHIPPING TRESHOLD WIDGET
 *  - Simple widget that adds a progress bar indicating how far they are for free shipping
 *  ===================================
 */

(function(w,d){
    const settings = {
        container: 'FSTContainer',
        progress_bar: 'FSTBar',
        message: 'FSTMessage',
        message_error: 'Please enter a target goal amount in the Theme Settings > Cart > Free Shipping Threshold'
    }
    let container = null;
    let data;
    let exchange_rate = Shopify.currency.rate;

    let initStarted = false;
    let observer = null;

    function initData() {
        const dataset = container.dataset.settings ?? new Object;
        if (Object.keys(dataset).length === 0) return;
        data = JSON.parse(dataset);
    }

    function fetchCartData() {
        fetch((window.theme.routes.cart ? window.theme.routes.cart : '/cart.js'), {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => calculateShipping(data));
    }

    function renderElements() {
        // Set data
        let currency_modifier = 1;
        let symbol = "$"
        let convert = false;
        if (data.shop_currency != data.cart_currency) {
            currency_modifier = exchange_rate;
            symbol = `${window.theme.settings.cartCurrencySymbol}`;
            convert = true;
        }
        const mod_target = data.target ? parseFloat(data.target) * currency_modifier : null;
        const mod_step_target = data.step_target ? parseFloat(data.step_target) * currency_modifier : null;
        
        const labelHTML = d.createElement('label')
        labelHTML.setAttribute('for', settings.progress_bar)
        // labelHTML.textContent = 'Free shipping progress'

        const progressBarHTML = d.createElement('progress')
        progressBarHTML.id = settings.progress_bar
        progressBarHTML.setAttribute('max', 100)
        progressBarHTML.setAttribute('value', 0)
        progressBarHTML.dataset.target = data.target ?? null

        const progressBarWrapper = d.createElement('div')
        progressBarWrapper.classList.add('fst-progress-bar-wrapper')
        progressBarWrapper.dataset.symbol = symbol
        if (convert) {
            if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                progressBarWrapper.dataset.target = mod_target.toFixed(0) ?? null
            } else {
                progressBarWrapper.dataset.target = mod_target.toFixed(2) ?? null
            }
        } else {
            progressBarWrapper.dataset.target = data.target ?? null
        }
        progressBarWrapper.appendChild(progressBarHTML)

        const messageHTML = d.createElement('div')
        messageHTML.id = settings.message
        messageHTML.classList.add('fst-message')

        container.appendChild(messageHTML);
        container.appendChild(labelHTML);
        
        // Step Label
        if (data.step_target && data.step_target != '') {
            const stepLabel = d.createElement('span');
            stepLabel.classList.add("fst-step-target");
            stepLabel.setAttribute('data-pos', `${(parseInt(data.step_target) / parseInt(data.target)) * 100}`);
            stepLabel.style.left = `${(parseInt(data.step_target) / parseInt(data.target)) * 100}%`;
            if (convert) {
                if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                    stepLabel.innerHTML = `${symbol}${mod_step_target.toFixed(0)}`;
                } else {
                    stepLabel.innerHTML = `${symbol}${mod_step_target.toFixed(2)}`;
                }
            } else {
                stepLabel.innerHTML = `$${data.step_target}`;
            }

            progressBarWrapper.appendChild(stepLabel);
        }
        
        container.appendChild(progressBarWrapper);
    }

    function calculateShipping(cartJson) {
        let currency_modifier = 1;
        let symbol = "$"
        let convert = false;
        if (data.shop_currency != data.cart_currency) {
            currency_modifier = exchange_rate;
            symbol = `${window.theme.settings.cartCurrencySymbol}`;
            convert = true;
            // cart_total = cart_total / exchange_rate;
        }

        const target = data.target ? parseFloat(data.target) : null;
        const mod_target = data.target ? parseFloat(data.target) * currency_modifier : null;
        let cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price) / 100;
        let mod_cart_total = cart_total / currency_modifier;

        let progress_value = (cart_total / target) * 100;
        progress_value = (mod_cart_total / target) * 100;

        const remaining = target - cart_total;
        const mod_remaining = mod_target - cart_total;
        let message = '';

        if (target) {
            // Set value of progress bar
            const pbar_elem = d.getElementById(settings.progress_bar);
            if (pbar_elem) {
                if (progress_value >= 100){
                    pbar_elem.setAttribute('value', 100);
                    pbar_elem.parentElement.setAttribute('value', 100);
                    pbar_elem.style.setProperty('--percentage', "calc(100% - 14px)");
                }
                else {
                    pbar_elem.setAttribute('value', progress_value ? progress_value : 0);
                    pbar_elem.parentElement.setAttribute('value', progress_value ? progress_value : 0);
                    pbar_elem.style.setProperty('--percentage', `calc(${progress_value ? progress_value : 0}% - 14px)`);
                }
            }
            

            const stepTarget = data.step_target ? parseFloat(data.step_target) : null;
            const mod_step_target = data.step_target ? parseFloat(data.step_target) * currency_modifier : null;
            const stepMessage = data.message_step_ongoing;

            // message = data.message_default.replace('[target]', `$${target}`);
            if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                message = data.message_default.replace('[target]', `${symbol}${mod_target.toFixed(0)}`);
            } else {
                message = data.message_default.replace('[target]', `${symbol}${mod_target.toFixed(2)}`);
            }
            if (mod_remaining <= 0) {
                message = data.message_success;
            }
            if (mod_remaining > 0 && mod_remaining < mod_target) {
                // message = data.message_ongoing.replace('[remaining]', `$${remaining ? remaining.toFixed(2) : target}`);
                if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                    message = data.message_ongoing.replace('[remaining]', `${symbol}${remaining ? mod_remaining.toFixed(0) : mod_target}`);
                } else {
                    message = data.message_ongoing.replace('[remaining]', `${symbol}${remaining ? mod_remaining.toFixed(2) : mod_target}`);
                }
            }

            if (stepTarget) {
                const mod_step_target = stepTarget * currency_modifier;
                const stepRemaining = stepTarget - cart_total;
                const mod_step_remaining = mod_step_target - cart_total;

                if (mod_step_remaining > 0) {
                    // message = stepMessage.replace('[remaining]', `$${stepRemaining ? stepRemaining.toFixed(2) : stepTarget}`);
                    if (data.cart_currency == 'JPY' || data.cart_currency == 'KRW') {
                        message = stepMessage.replace('[remaining]', `${symbol}${stepRemaining ? mod_step_remaining.toFixed(0) : mod_step_target}`);
                    } else {
                        message = stepMessage.replace('[remaining]', `${symbol}${stepRemaining ? mod_step_remaining.toFixed(2) : mod_step_target}`);
                    }
                }
            }
        }
        else
            message = settings.message_error

        // Display message
        d.getElementById(settings.message).innerHTML = message;

        // Hide free shipping widget when cart has a product type of "Rods" or "Rods - Seacore"
        let rodsChecker = cartJson.items.find(x => x.product_type === 'Rods' || x.product_type === 'Rods - Seacore' );

        if ( rodsChecker ) {
            document.querySelector('#CartDrawer .cart-drawer__header').classList.add('has-rods');
        } else {
            document.querySelector('#CartDrawer .cart-drawer__header').classList.remove('has-rods');
        }
    }

    function init() {
        if (initStarted) return;
        
        container = d.getElementById(settings.container);

        if (!container) {
            watchForContainer();
            return;
        }

        initStarted = true;

        initData();
        renderElements();
        fetchCartData();

        // Listeners for product added and cart updates
        ['cart:update', 'ajaxProduct:added'].forEach(evt =>
            d.addEventListener(evt, fetchCartData, false)
        );

        if (observer) observer.disconnect();
    }

    function watchForContainer() {
        if (observer) return;

        observer = new MutationObserver(() => {
            const found = document.getElementById(settings.container);
            if (found) {
                container = found;
                init();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    init();
})(window, document)

class VariantSelect extends HTMLElement {
    constructor() {
        super();
        this.location = this.getAttribute('data-location');
        this.selectedVariantImageId = null;
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handlePointerOver = this.handlePointerOver.bind(this);
        this.handlePointerOut = this.handlePointerOut.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleSwatchesMouseLeave = this.handleSwatchesMouseLeave.bind(this);
    }

    connectedCallback() {
        this.addEventListener('change', this.handleChange);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('pointerover', this.handlePointerOver);
        this.addEventListener('pointerout', this.handlePointerOut);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        this.swatchesContainer = this.querySelector('.product-card-variant-select__swatches');
        this.swatchesContainer?.addEventListener('mouseleave', this.handleSwatchesMouseLeave);
        this.syncSelectedState();
        this.selectedVariantImageId = this.getSelectedVariantImageId();
        requestAnimationFrame(() => this.scrollSelectedSwatchIntoView(null, 'auto'));
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('pointerover', this.handlePointerOver);
        this.removeEventListener('pointerout', this.handlePointerOut);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.swatchesContainer?.removeEventListener('mouseleave', this.handleSwatchesMouseLeave);
    }

    handleChange(event) {
        const source = event.target;
        if (!(source instanceof HTMLInputElement || source instanceof HTMLSelectElement)) return;

        const selectedOptionElement = source instanceof HTMLSelectElement ? source.selectedOptions[0] : source;
        if (!selectedOptionElement) return;

        const selectedOption = selectedOptionElement.value;
        this.syncSelectedState(selectedOptionElement);
        let variantImageId = selectedOptionElement.getAttribute('data-variant-image');
        let variantImageUrl = null;
        this.selectedVariantImageId = variantImageId || this.getSelectedVariantImageId();
        if(this.location === 'cart-upsell') {
            variantImageId = null;
            variantImageUrl = selectedOptionElement.getAttribute('data-variant-image');
        }
        this.updateVariantImage(variantImageId, variantImageUrl);
        this.updateQuickAddButton(selectedOption);
        this.updatePrice(selectedOptionElement);
        this.updateProductLink(selectedOptionElement);
        this.dispatchEvent(
            new CustomEvent(ThemeEvents.variantSelected, {
                bubbles: true,
                detail: {
                    resource: {
                        id: selectedOption,
                    },
                },
            })
        );
        this.updateProductFormState(selectedOptionElement);
        this.scrollSelectedSwatchIntoView(selectedOptionElement);
    }

    handleClick(event) {
        const trigger = event.target instanceof Element
            ? event.target.closest('[data-carousel-previous], [data-carousel-next]')
            : null;

        if (!trigger) return;

        event.preventDefault();

        if (trigger.hasAttribute('data-carousel-previous')) {
            this.scrollCarousel(-1);
        } else if (trigger.hasAttribute('data-carousel-next')) {
            this.scrollCarousel(1);
        }
    }

    handlePointerOver(event) {
        if (event.pointerType !== 'mouse') return;

        const swatchLabel = event.target instanceof Element
            ? event.target.closest('.product-card-variant-select__swatch-label')
            : null;
        if (!(swatchLabel instanceof HTMLElement) || !this.contains(swatchLabel)) return;

        const relatedLabel = event.relatedTarget instanceof Element
            ? event.relatedTarget.closest('.product-card-variant-select__swatch-label')
            : null;
        if (relatedLabel === swatchLabel) return;

        const swatchInput = swatchLabel.querySelector('input[data-variant-image]');
        const variantImageId = swatchInput?.getAttribute('data-variant-image');
        if (!variantImageId) return;

        this.updateVariantImage(variantImageId, null);
    }

    handlePointerOut(event) {
        if (event.pointerType !== 'mouse') return;

        const swatchLabel = event.target instanceof Element
            ? event.target.closest('.product-card-variant-select__swatch-label')
            : null;
        if (!(swatchLabel instanceof HTMLElement) || !this.contains(swatchLabel)) return;

        const nextLabel = event.relatedTarget instanceof Element
            ? event.relatedTarget.closest('.product-card-variant-select__swatch-label')
            : null;
        if (nextLabel && this.contains(nextLabel)) return;

        this.resetHoveredVariantPreview();
    }

    handleMouseLeave() {
        this.resetHoveredVariantPreview();
    }

    handleSwatchesMouseLeave() {
        this.resetHoveredVariantPreview();
    }

    resetHoveredVariantPreview() {
        const selectedVariantImageId = this.selectedVariantImageId || this.getSelectedVariantImageId();
        if (selectedVariantImageId) {
            this.updateVariantImage(selectedVariantImageId, null);
        }
    }

    getSelectedVariantImageId() {
        const checkedInput = this.querySelector('input[type="radio"]:checked[data-variant-image]');
        if (checkedInput instanceof HTMLInputElement && checkedInput.dataset.variantImage) {
            return checkedInput.dataset.variantImage;
        }

        const selectedInput = this.querySelector('input[type="radio"][data-selected="true"][data-variant-image]');
        if (selectedInput instanceof HTMLInputElement && selectedInput.dataset.variantImage) {
            return selectedInput.dataset.variantImage;
        }

        const select = this.querySelector('select');
        const selectedOption = select?.selectedOptions?.[0];
        return selectedOption?.getAttribute('data-variant-image') || null;
    }

    syncSelectedState(selectedOptionElement = null) {
        const radioInputs = this.querySelectorAll('input[type="radio"][data-variant-id]');
        if (!radioInputs.length) return;

        const currentInput =
            selectedOptionElement instanceof HTMLInputElement
                ? selectedOptionElement
                : this.querySelector('input[type="radio"]:checked[data-variant-id]') ||
                  this.querySelector('input[type="radio"][data-selected="true"][data-variant-id]');

        radioInputs.forEach((input) => {
            input.dataset.selected = 'false';
        });

        if (currentInput instanceof HTMLInputElement) {
            currentInput.dataset.selected = 'true';
        }
    }

    scrollCarousel(direction) {
        const swatchesContainer = this.querySelector('.product-card-variant-select__swatches');
        if (!(swatchesContainer instanceof HTMLElement)) return;

        const items = Array.from(this.querySelectorAll('.product-card-variant-select__swatch-item'));
        if (items.length <= 1) return;

        const containerCenter = swatchesContainer.scrollLeft + swatchesContainer.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
            if (!(item instanceof HTMLElement)) return;

            const itemCenter = item.offsetLeft + item.offsetWidth / 2;
            const distance = Math.abs(itemCenter - containerCenter);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });

        const nextIndex = (closestIndex + direction + items.length) % items.length;
        const nextItem = items[nextIndex];
        if (!(nextItem instanceof HTMLElement)) return;

        const targetLeft = nextItem.offsetLeft - (swatchesContainer.clientWidth / 2) + (nextItem.offsetWidth / 2);
        const maxScrollLeft = swatchesContainer.scrollWidth - swatchesContainer.clientWidth;
        const clampedLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

        swatchesContainer.scrollTo({
            left: clampedLeft,
            behavior: 'smooth',
        });
    }

    scrollSelectedSwatchIntoView(selectedOptionElement = null, behavior = 'smooth') {
        const swatchesContainer = this.querySelector('.product-card-variant-select__swatches');
        if (!(swatchesContainer instanceof HTMLElement)) return;

        const currentInput =
            selectedOptionElement instanceof HTMLInputElement
                ? selectedOptionElement
                : this.querySelector('input[type="radio"]:checked[data-variant-id]') ||
                  this.querySelector('input[type="radio"][data-selected="true"][data-variant-id]');

        const currentItem = currentInput?.closest('.product-card-variant-select__swatch-item');
        if (!(currentItem instanceof HTMLElement)) return;

        const containerWidth = swatchesContainer.clientWidth;
        const itemWidth = currentItem.offsetWidth;
        const targetLeft = currentItem.offsetLeft - (containerWidth / 2) + (itemWidth / 2);
        const maxScrollLeft = swatchesContainer.scrollWidth - containerWidth;
        const clampedLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

        swatchesContainer.scrollTo({
            left: clampedLeft,
            behavior,
        });
    }

    updateVariantImage(variantImageId, variantImageUrl) {
        if (variantImageId) {
            const card = this.closest('product-card');
            if (card && typeof card.showVariantMedia === 'function') {
                card.showVariantMedia(variantImageId);
                return;
            }

            const slideshow = card?.querySelector('slideshow-component');
            if (!slideshow) return;
            const slides = slideshow.refs?.slides ?? slideshow.querySelectorAll('slideshow-slide[variant-image]');
            const mediaId = String(variantImageId);
            if (slides?.length) {
                for (const slide of slides) {
                    if (!slide.hasAttribute('variant-image')) continue;
                    const isSelected = slide.getAttribute('slide-id') === mediaId;
                    slide.hidden = !isSelected;
                    slide.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
                    if (!isSelected) slide.removeAttribute('reveal');
                }
            }
            if (typeof slideshow.select === 'function') {
                slideshow.select({ id: mediaId }, undefined, { animate: false });
            }
        } else if (variantImageUrl) {
            const upsell = this.closest('.product-card-upsell');
            const image = upsell?.querySelector('.product-card-upsell__image img');
            if (image) image.src = variantImageUrl;
        }
    }

    updateQuickAddButton(variantId) {
        let parent = this.closest('product-card');
        if(this.location === 'cart-upsell') {
            parent = this.closest('.product-card-upsell');
        } 
          
        if (!parent) return;
        // Update variant ID in every product form on the card (quick-add + buy-buttons).
        // product-form.js submits via FormData(form), so the current input value is used.
        const variantInputs = parent.querySelectorAll('product-form-component input[name="id"]');
        variantInputs.forEach((input) => {
            input.value = variantId;
            // Re-enable so the form can submit; theme may have disabled it for unavailable variant
            input.removeAttribute('disabled');
        });
    }

    updatePrice(selectedOptionElement) {
        let parent = this.closest('product-card');
        if(this.location === 'cart-upsell') {
            parent = this.closest('.product-card-upsell');
        } 
        if (!parent || !(selectedOptionElement instanceof Element)) return;

        const priceContainer = parent.querySelector('[ref="priceContainer"] .price');
        if (!priceContainer) return;

        // Both select options and swatch radios carry their rendered price parts.
        const newPriceMajor = selectedOptionElement.getAttribute('data-price-major');
        const newPriceMinor = selectedOptionElement.getAttribute('data-price-minor');
        if (newPriceMajor === null) return;

        let newPriceElement = `<span class="price-dollars">${newPriceMajor}</span>`;
        if (newPriceMinor) {
            newPriceElement += `<span class="price-cents">.${newPriceMinor}</span>`;
        }
        priceContainer.innerHTML = newPriceElement;
    }
}

if(!customElements.get('variant-select')) {
    customElements.define('variant-select', VariantSelect);
}

class CartCrossSell extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSlider();
    }

    initSlider() {
        const slider = tns({
            container: this.querySelector('.cross-sell-products'),
            items: 1,
            slideBy: 1,
            autoplay: false,
            loop: false,
            controls: true,
            navPosition: 'bottom',
            prevButton: this.querySelector('.cross-sell-products__prev'),
            nextButton: this.querySelector('.cross-sell-products__next'),
        });
    }
}

if(!customElements.get('cart-cross-sell')) {
    customElements.define('cart-cross-sell', CartCrossSell);
}

// PDP Specs Table
window.addEventListener('DOMContentLoaded', () => {
    const rodVariantSpecsElems = document.querySelectorAll('.specs-table__content[data-variant-id]');
    if (rodVariantSpecsElems.length > 0) {
        document.addEventListener(ThemeEvents.variantUpdate, (e) => {
            // hide other tables
            rodVariantSpecsElems.forEach(elem => {
                elem.classList.add('hidden');
            })
            // show selected table
            const selectedVariantTable = document.querySelector(`.specs-table__content[data-variant-id="${e.detail?.resource?.id}"]`);
            if (selectedVariantTable) {
                selectedVariantTable.classList.remove('hidden');
            }
        });
    }
})

const KLAVIYO_BIS_COMPANY_ID = 'UCr9Cd';
const KLAVIYO_BIS_REVISION = '2024-06-15';

function getKlaviyoBisRoot(target) {
    return target.closest('[data-klaviyo-bis-root]');
}

function resetKlaviyoBisState(root) {
    if (!root) return;

    const emailInput = root.querySelector('[data-klaviyo-bis-email]');
    const status = root.querySelector('[data-klaviyo-bis-status]');
    const success = root.querySelector('[data-klaviyo-bis-success]');
    const formView = root.querySelector('.klaviyo-bis__form-view');
    const submit = root.querySelector('[data-klaviyo-bis-submit]');

    root.removeAttribute('data-klaviyo-bis-loading');

    if (emailInput) emailInput.value = '';

    if (status) {
        status.textContent = '';
        status.dataset.status = '';
        status.classList.add('hidden');
    }

    formView?.classList.remove('hidden');
    success?.classList.add('hidden');

    if (submit) {
        submit.disabled = false;
        submit.textContent = 'Notify me when available';
    }
}

function getKlaviyoBisVariantId(root) {
    const currentVariantInput = root.closest('.buy-buttons-block')?.querySelector('product-form-component input[name="id"]');
    return currentVariantInput?.value || root.dataset.klaviyoBisVariantId || '';
}

async function submitKlaviyoBis(root) {
    if (!root || root.dataset.klaviyoBisLoading === 'true') return;

    const emailInput = root.querySelector('[data-klaviyo-bis-email]');
    const status = root.querySelector('[data-klaviyo-bis-status]');
    const submit = root.querySelector('[data-klaviyo-bis-submit]');
    const formView = root.querySelector('.klaviyo-bis__form-view');
    const success = root.querySelector('[data-klaviyo-bis-success]');

    if (!(emailInput instanceof HTMLInputElement) || !(submit instanceof HTMLButtonElement)) return;

    if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
    }

    const variantId = getKlaviyoBisVariantId(root);
    if (!variantId) {
        if (status) {
            status.textContent = 'We could not determine the selected variant. Please try again.';
            status.dataset.status = 'error';
            status.classList.remove('hidden');
        }
        return;
    }

    const payload = {
        data: {
            type: 'back-in-stock-subscription',
            attributes: {
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email: emailInput.value.trim(),
                        },
                    },
                },
                channels: ['EMAIL'],
            },
            relationships: {
                variant: {
                    data: {
                        type: 'catalog-variant',
                        id: `$shopify:::$default:::${variantId}`,
                    },
                },
            },
        },
    };

    root.dataset.klaviyoBisLoading = 'true';
    submit.disabled = true;
    submit.textContent = 'Submitting...';

    if (status) {
        status.textContent = '';
        status.dataset.status = '';
        status.classList.add('hidden');
    }

    const requestController = new AbortController();
    const requestTimeout = window.setTimeout(() => requestController.abort(), 10000);

    try {
        let response;

        try {
            response = await fetch(
                `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_BIS_COMPANY_ID}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        revision: KLAVIYO_BIS_REVISION,
                    },
                    body: JSON.stringify(payload),
                    signal: requestController.signal,
                }
            );
        } finally {
            window.clearTimeout(requestTimeout);
        }

        if (!response.ok) {
            let errorMessage = 'Something went wrong. Please try again.';

            try {
                const responseJson = await response.json();
                errorMessage = responseJson?.errors?.[0]?.detail || errorMessage;
            } catch (error) {
                // Keep the fallback message when the client endpoint returns a non-JSON error body.
            }

            throw new Error(errorMessage);
        }

        formView?.classList.add('hidden');
        success?.classList.remove('hidden');
    } catch (error) {
        if (status) {
            status.textContent = error instanceof Error && error.name === 'AbortError'
                ? 'The request timed out. Please try again.'
                : error instanceof Error ? error.message : 'Something went wrong. Please try again.';
            status.dataset.status = 'error';
            status.classList.remove('hidden');
        }
    } finally {
        root.removeAttribute('data-klaviyo-bis-loading');
        submit.disabled = false;
        submit.textContent = 'Notify me when available';
    }
}

document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-klaviyo-bis-trigger]');
    if (trigger) {
        const root = getKlaviyoBisRoot(trigger);
        resetKlaviyoBisState(root);
        window.setTimeout(() => {
            root?.querySelector('[data-klaviyo-bis-email]')?.focus();
        }, 0);
        return;
    }

    const submit = event.target.closest('[data-klaviyo-bis-submit]');
    if (submit) {
        event.preventDefault();
        submitKlaviyoBis(getKlaviyoBisRoot(submit));
    }
});

// Close any open BIS dialog before the featured product section morphs so the UI never keeps stale variant data.
document.addEventListener(ThemeEvents.variantUpdate, () => {
    document.querySelectorAll('[data-klaviyo-bis-dialog][open]').forEach((dialog) => {
        const component = dialog.closest('dialog-component');
        if (component && typeof component.closeDialog === 'function') {
            component.closeDialog();
            return;
        }

        if (dialog instanceof HTMLDialogElement) {
            dialog.close();
        }
    });
});
